import React, { useEffect, useRef, useState } from "react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { AgeWall } from "@/components/AgeWall";
import {
  AGE_BLOCK_EVENT, ageAssurancePayload, checkAgeRange, getAgeBlock, isBlocking, isIosNative, markAgeRangeSent, setAgeBlock,
} from "@/lib/ageRange";

// Rattache la tranche Apple au compte (une fois par compte et par réponse) — jamais de date de naissance.
export async function syncAgeAssurance(rec, userId) {
  const payload = ageAssurancePayload(rec);
  if (!payload || !userId || rec.sentFor === userId) return null;
  try {
    const { data } = await api.post("/auth/age-assurance", payload);
    markAgeRangeSent(userId);
    return data;
  } catch { return null; }
}

// iOS 26+ uniquement (no-op ailleurs). Vérifie la tranche d'âge Apple pour toute SESSION (connexion, démarrage
// avec session — membres existants après la mise à jour) : < 13 ou partage requis refusé → déconnexion sur cet
// appareil + mur. Le mur est aussi affiché quand l'inscription (Onboarding) pose un blocage via setAgeBlock.
export const AgeAssuranceGate = () => {
  const { user, loading, logout } = useApp();
  const [block, setBlock] = useState(getAgeBlock());
  const checkedFor = useRef(null);

  useEffect(() => {
    const onBlock = (e) => setBlock(e.detail || null);
    window.addEventListener(AGE_BLOCK_EVENT, onBlock);
    return () => window.removeEventListener(AGE_BLOCK_EVENT, onBlock);
  }, []);

  useEffect(() => {
    if (loading || !user?.id || !isIosNative()) return;
    if (checkedFor.current === user.id) return;
    checkedFor.current = user.id;
    (async () => {
      const r = await checkAgeRange();
      await syncAgeAssurance(r, user.id);
      if (isBlocking(r.verdict)) {
        setAgeBlock({ verdict: r.verdict, rec: r, reason: "session" });
        try { await logout(); } catch { /* noop */ }
      }
    })();
  }, [user?.id, loading, logout]);

  // Nouveau compte → la vérification repart de zéro (checkedFor) ; déconnexion → rien à faire.
  useEffect(() => { if (!user) checkedFor.current = null; }, [user]);

  if (!block) return null;
  const retry = async () => {
    const r = await checkAgeRange({ force: true });
    if (isBlocking(r.verdict)) setAgeBlock({ ...block, verdict: r.verdict, rec: r });
    else setAgeBlock(null);
  };
  return <AgeWall block={block} onRetry={retry} />;
};
